export enum TreeNodeEventType {
    NodeClicked = 'NodeClicked',
    NodeHandleClicked = 'NodeHandleClicked',
    NodeDropped = 'NodeDropped'
}